import { Component, OnInit } from '@angular/core';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private authAndACL: AuthAndACLService, private route: ActivatedRoute) { }

  login(): void{
    this.route.queryParams.forEach((params: Params) => {
      let path:string = params['path'];
      let token:string = params['t'];
      this.authAndACL.dadosUsuario(path,token);
    });
  }

  ngOnInit() {
    this.login();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts